var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.role && _vm.role === 'admin')?_c('Menu'):_vm._e(),(_vm.role && _vm.role === 'admin_enterprise')?_c('MenuEnterprise'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }